/*
 * Tine 2.0
 *
 * @package     Setup
 * @license     http://www.gnu.org/licenses/agpl.html AGPL Version 3
 * @author      Cornelius Weiß <c.weiss@metaways.de>
 * @copyright   Copyright (c) 2018 Metaways Infosystems GmbH (http://www.metaways.de)
 */

require('./init');
require('./Model');
require('./TreePanel');
require('./MainScreen');
require('./TermsPanel');
require('./ApplicationGridPanel');
require('./EnvCheckGridPanel');
require('./ConfigManagerPanel');
require('./AuthenticationPanel');
require('./EmailPanel');
require('../css/Setup.css');
